
export const VIEW_PREP = "view-prep";
export const TEST = "test";
export const ONBOARDING_FORMS = "onboarding-forms";
export const COURSE_INDEX = "course-index";
export const TOPIC_FOCUS_SESSIONS = "topic-focus-sessions";
export const TOPIC_FOCUS = "topic-focus";
export const PRACTICE = "practice";
export const LAUNCH_TEST = "launch-test";
export const ADD_TO_STUDY_PLAN = "add-to-study-plan";
export const STUDY_PLANNER = "study-planner";
export const STUDY_PLANNER_FORM = "study-planner-form";
export const RESCHEDULE_EVENT = "reschedule-event";
export const UNLOCK = "unlock";
export const ALERT = "alert";
export const DRILL = "drill";
export const DRILL_SMART = "drill-smart";
export const STUDY_RECOMMENDATIONS_TOOL = "study-recommendations-tool";
export const APPEAL = "appeal";
export const LAUNCH_PRACTICE_TEST = "launch-practice-test";
export const SELF_PACED = "self-paced";
export const GMAT_MATERIAL = "gmat-material";